import Element from '../../../core/Element';
import type { Tools } from '../../../core/types';
import withEventTracking from '../../../utilities/withEventTracking';
import type { State, Type } from './state';
import { useCarousel, TRIGGER } from './state';
import React from 'react';

export interface NextProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: (state: State, type: Type) => void;
  tools?: Tools;
  qeID?: string;
  ariaLabelNext?: string;
}

const Next = ({
  children = 'Next',
  className,
  onClick,
  qeID,
  ariaLabelNext = 'Next Slide',
}: NextProps): React.ReactElement => {
  const [, navigate] = useCarousel();
  const onAction = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate.next(onClick, TRIGGER.ARROW);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowRight') {
      navigate.next(onClick, TRIGGER.ARROW);
    }
  };

  return (
    <Element
      data-testid="next-arrow"
      onKeyDown={handleKeyPress}
      Component="button"
      type="button"
      className={className}
      onClick={onAction}
      aria-label={ariaLabelNext}
      data-qe-id={qeID}
      theme={{
        focusDark: true,
      }}
    >
      {children}
    </Element>
  );
};

export default withEventTracking<NextProps>(Next);
